<template>
    <div>
        <el-select 
            v-if="mode == 'edit'"
            :ref="reference"
            v-model="tmpValue"
            filterable 
            multiple 
            remote
            :placeholder="prop.placeholder ? prop.placeholder : this.$l10n.__('Rechercher')" 
            :remote-method="remoteMethod"
            :loading="loading"
            @remove-tag="remove"
            class="wp-10">
                <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="parseInt(item.id)">
                </el-option>
        </el-select>
        <person-list v-else :list="options"/>
    </div>
</template>

<script>
    import CfMixin from '../../../mixins/CustomfieldInputsMixins'
    import MultipleMixin from '../../../mixins/MultipleInputsMixins'
    import PersonList from 'vcomponents/utilities/PersonList.vue';

    export default {
        mixins: [CfMixin, MultipleMixin],
        methods: {
            remoteMethod: _.debounce(function(query) {
                if (query !== '') {
                    this.loading = true;
                    // ajax method to get third with type & name
                    this.$ajax.get(`/rest/thirds/autocomplete`, {q: query, types: this.allowedType},
                        (response) => {
                            this.options = response
                            this.loading = false
                        }, 
                        (error) => {
                            this.close()
                            Push.error(this.$l10n.__("Problème lors de la récupération des données"))
                        }
                    );

                   
                } else {
                    this.options = [];
                }
            }, 500),
            checkParams(newValue) {
                let valid = true
                valid = this.checkMinMaxParams(newValue)
                return valid
            },
        },
        computed: {
            allowedType(){
                let allowedType = []
                if(this.prop.allowedValues.length > 0){
                    this.prop.allowedValues.map(val => {
                        allowedType.push(val.name)
                    })
                }
                return allowedType
            }
        },

        components: {
            'person-list': PersonList,
        }
    }
</script>
